import styled from 'styled-components';
import {
  alto,
  bigStone,
  blueMana,
  darkerBlackPearl,
  paradigmLightBlue,
} from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT, FONT_FAMILY } from '#/units';
import ArrowDown from '@paradigm/design-system/src/assets/ArrowDown';

export const VIRTUAL_ROW_HEIGHT = 42;
export const MOBILE_VIRTUAL_ROW_HEIGHT = 52;

export const TableComponent = styled.table`
  table-layout: fixed;
  background-color: ${darkerBlackPearl};
  position: absolute; //So we can overflow the container
  min-width: 100%;
  width: max-content;
  font-family: ${FONT_FAMILY.sans};
  overflow: auto;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    position: relative;
    overflow: hidden;
    table-layout: auto;
    width: 100%;
    height: 100%;
  }
`;

export const TBody = styled.tbody`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    position: relative;
    max-height: 100%;
  }
`;

export const THead = styled.thead`
  background-color: ${darkerBlackPearl};
  margin: 0;
  position: sticky;
  top: 0;
  z-index: 10;
  height: 43px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: none;
  }
`;
export const HeaderRow = styled.tr`
  color: ${paradigmLightBlue};
  font-family: ${FONT_FAMILY.sans};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  box-shadow: inset 0 -1px 0 0 ${bigStone}, 0 -1px 0 0 ${bigStone};
`;

export const TableContainer = styled.div`
  display: flex;
  flex: 1;
  max-width: 100vw;
  overflow: auto;
  font-family: ${FONT_FAMILY.sans};
  font-size: 14px;
  position: relative; //So table can overflow this container
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    overflow: hidden;
  }
`;

export const TPadding = styled.td<{ height: number }>`
  display: ${({ height }) => (height > 0 ? 'block' : 'none')};
  height: ${({ height }) => `${height}px`};
`;

export const RowComponent = styled.tr<{ expanded?: boolean }>`
  height: ${VIRTUAL_ROW_HEIGHT}px;
  color: #ffffff;
  font-family: ${FONT_FAMILY.sans};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
  box-shadow: inset 0 -1px 0 0 ${bigStone}, 0 -1px 0 0 ${bigStone};
  max-height: ${VIRTUAL_ROW_HEIGHT}px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: ${MOBILE_VIRTUAL_ROW_HEIGHT}px;
    ${({ expanded }) => expanded === true && `box-shadow:unset;`};
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    padding: 0.875rem;
    max-height: ${MOBILE_VIRTUAL_ROW_HEIGHT}px;
  }
`;

export const ExpandedContent = styled.tr<{ expanded: boolean }>`
  display: none;
  font-family: ${FONT_FAMILY.sans};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 100%;
    display: ${({ expanded }) => (expanded ? 'block' : 'none')};
    padding: 0.875rem;
    border-bottom: 1px solid ${bigStone};
  }
`;
export const CellLeftPadding = styled.div<{ depth: number }>`
  padding-left: ${({ depth }) => depth}rem;
  display: flex;
`;

export const TdCell = styled.td<{ cellWidth?: number }>`
  ${({ cellWidth }) =>
    cellWidth != null ? `width: ${cellWidth}px;` : 'flex: 1;'}
`;

export const CheckboxContainer = styled.div`
  padding: 0px 0px;
  display: flex;
  justify-content: center;
`;

export const ExpandedCell = styled.tr`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-auto-flow: column;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  align-items: center;
`;

export const ExpandedTitle = styled.td`
  color: ${blueMana};
  font-size: 1rem;
  line-height: 1.5rem;
`;

export const HorizontalDivider = styled.tr`
  display: flex;
  height: 1px;
  width: 100%;
  background: linear-gradient(
    to right,
    ${darkerBlackPearl},
    ${bigStone},
    ${darkerBlackPearl}
  );
`;

export const MobileExpandCell = styled(ArrowDown)<{ expanded?: boolean }>`
  fill: ${alto};
  ${({ expanded }) =>
    expanded === true ? 'transform: rotate(180deg);' : 'opacity: 0.5;'}
`;
